import { tok } from './risk'

/** Auto-scaling sparkline with a soft fill and an emphasised endpoint. */
export function Sparkline({
  points,
  color = tok('--flare'),
  width = 120,
  height = 36,
}: {
  points: number[]
  color?: string
  width?: number
  height?: number
}) {
  if (points.length < 2) return null
  const mn = Math.min(...points)
  const mx = Math.max(...points)
  const rng = mx - mn || 1
  const pad = 3
  const X = (i: number) => pad + (i * (width - pad * 2)) / (points.length - 1)
  const Y = (v: number) => height - pad - ((v - mn) / rng) * (height - pad * 2)
  const line = points.map((v, i) => `${i ? 'L' : 'M'}${X(i).toFixed(1)} ${Y(v).toFixed(1)}`).join(' ')
  const last = points.length - 1
  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      style={{ width: '100%', height }}
    >
      <path
        d={`${line} L${X(last).toFixed(1)} ${height - pad} L${pad} ${height - pad} Z`}
        fill={color}
        fillOpacity={0.14}
      />
      <path d={line} fill="none" stroke={color} strokeWidth={2} vectorEffect="non-scaling-stroke" />
      <circle cx={X(last)} cy={Y(points[last])} r={2.7} fill={color} />
    </svg>
  )
}
